import { getRequestParams } from "../../pages_android/custom_views/insta_custom_views/utils_android/CookieHelper"
import fetchWithTimeout, { getHttpParams, getRequestUrl } from "../../pages_android/custom_views/insta_custom_views/utils_android/UrlHelperAndroid"
import { error, log, onResponse } from "./ApiUtils"

export class UsersApi {

    static getMyFriends(onSuccess, onError) {
        const params = getRequestParams()
        fetchWithTimeout(getRequestUrl() + "getMyFriends", getHttpParams(params)).then((response) => response.json())
        .then((responseData) => {
            log("getMyFriends response = ", responseData)
            onResponse(responseData, onSuccess, onError)
        })
        .catch((e) => {
            log("getMyFriends error = ", e)
            error(onError, { response: -1 })
        })
    }
    static getMyInfoEmployer(onSuccess, onError) {
        const params = getRequestParams()
        fetchWithTimeout(getRequestUrl() + "getMyInfoEmployer", getHttpParams(params)).then((response) => response.json())
        .then((responseData) => {
            log("getMyInfoEmployer response = ", responseData)
            onResponse(responseData, onSuccess, onError)
        })
        .catch((e) => {
            log("getMyInfoEmployer error = ", e)
            error(onError, { response: -1 })
        })
    }


}
